import React from 'react'
import Header from './Header'
import Hero from './Hero'
import Footer from './Footer'
import CookieConsent from 'react-cookie-consent'

const  HomeTop = () =>{
  return (
    <>
        <div className='sticky top-0 w-full z-50 overflow-x-hidden overflow-y-hidden'>  <Header/></div>
          <Hero/>   
        <Footer/> 
    </>
  )
}

export default HomeTop
